import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLSystemInfoClient } from "./api/cplapi/CPLAPI";

export interface ISystemInfoService {
  getMaxAllowedContentLength(): Promise<number>;
}

@injectable()
export class SystemInfoService implements ISystemInfoService {
  @inject(SERVICE_TYPES.CPLSystemInfoClient) cplSystemInfoClient!: ICPLSystemInfoClient;

  async getMaxAllowedContentLength(): Promise<number> {
    return await this.cplSystemInfoClient.getMaxAllowedContentLength();
  }
}
